//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { VideoBlock } from "@/utils/dto/art.js";

const VIDEO_LABELS = {
  vk_video: 'VK Video',
  youtube: 'YouTube',
  rutube: 'RuTube',
}

function parseUrl(value) {
  try {
    return new URL(String(value || '').trim())
  } catch (e) {
    return null
  }
}

function isVerticalUrl(url) {
  const source = `${url.hostname}${url.pathname}`.toLowerCase()
  return source.includes('/shorts/') || source.includes('/clip') || source.includes('/clips/')
}

function getYoutubeEmbedUrl(url) {
  const host = url.hostname.toLowerCase()
  let id = ''

  if (host === 'youtu.be' || host.endsWith('.youtu.be')) {
    id = url.pathname.split('/').filter(Boolean)[0] || ''
  } else if (url.pathname.startsWith('/shorts/')) {
    id = url.pathname.split('/').filter(Boolean)[1] || ''
  } else if (url.pathname.startsWith('/embed/')) {
    id = url.pathname.split('/').filter(Boolean)[1] || ''
  } else {
    id = url.searchParams.get('v') || ''
  }

  return id ? `https://www.youtube.com/embed/${id}` : ''
}

function getRutubeEmbedUrl(url) {
  const parts = url.pathname.split('/').filter(Boolean)
  const videoIndex = parts.findIndex(part => part === 'video')
  const embedIndex = parts.findIndex(part => part === 'play' || part === 'embed')
  const id = videoIndex >= 0
    ? parts[videoIndex + 1]
    : embedIndex >= 0
      ? parts[embedIndex + 2] || parts[embedIndex + 1]
      : parts[parts.length - 1]

  return id ? `https://rutube.ru/play/embed/${id}` : ''
}

function getVkEmbedUrl(url) {
  const match = decodeURIComponent(`${url.pathname}${url.search}`).match(/(video|clip)(-?\d+)_(\d+)/)
  if (!match) return ''

  const [, type, oid, id] = match
  if (type === 'clip') {
    return `https://vk.com/clip_ext.php?oid=${oid}&id=${id}`
  }

  return `https://vk.com/video_ext.php?oid=${oid}&id=${id}&hd=2`
}

function getVideoEmbed(field, value) {
  const url = parseUrl(value)
  if (!url) return null

  const embedUrl = field === 'youtube'
    ? getYoutubeEmbedUrl(url)
    : field === 'rutube'
      ? getRutubeEmbedUrl(url)
      : getVkEmbedUrl(url)

  if (!embedUrl) return null

  return {
    key: field,
    label: VIDEO_LABELS[field],
    embedUrl,
    isVertical: isVerticalUrl(url),
  }
}

export default {
  name: "VideoBlockComponent",
  props: {
    block: {
      type: [VideoBlock, Object],
      default: () => ({}),
    },
  },
  data() {
    return {
      activeKey: null,
    }
  },
  computed: {
    videos() {
      return ['vk_video', 'youtube', 'rutube']
        .map(field => getVideoEmbed(field, this.block?.data?.[field]))
        .filter(Boolean)
    },
  },
  watch: {
    videos: {
      immediate: true,
      handler(videos) {
        if (!videos.length) {
          this.activeKey = null
          return
        }
        if (!videos.some(video => video.key === this.activeKey)) {
          this.activeKey = videos[0].key
        }
      },
    },
  },
}
